// extracted by mini-css-extract-plugin
module.exports = {"icon":"SliderButton_icon__TmG52","sr-only":"SliderButton_sr-only__xrMaj"};